import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface UpdateTextBlockCriteria {
    widgetId: string;
    richText: string;
}

class UpdateTextBlockCriteriaImpl implements UpdateTextBlockCriteria {
    constructor(readonly widgetId: string, readonly richText: string) {}
}

export class UpdateTextBlockCriteriaBuilder {
    private widgetId: Option<string> = none;

    private richText: Option<string> = none;

    static create = (): UpdateTextBlockCriteriaBuilder => new UpdateTextBlockCriteriaBuilder();

    withWidgetId = (widgetId: string): UpdateTextBlockCriteriaBuilder => {
        this.widgetId = some(widgetId);
        return this;
    };

    withRichText = (richText: string): UpdateTextBlockCriteriaBuilder => {
        this.richText = some(richText);
        return this;
    };

    build = (): UpdateTextBlockCriteria => {
        if (isNone(this.widgetId) || isNone(this.richText)) {
            throw new ReferenceError('Undefined prop');
        }

        return new UpdateTextBlockCriteriaImpl(this.widgetId.value, this.richText.value);
    };
}
